import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, Suspense as _Suspense, withCtx as _withCtx, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition } from "vue";
const _hoisted_1 = { class: "w-full flex items-center justify-between px-3 py-3" };
const _hoisted_2 = { class: "text-3xl font-medium text-badge" };
const _hoisted_3 = { class: "w-full flex-1 overflow-hidden p-2" };
const _hoisted_4 = { class: "size-16" };
const _hoisted_5 = { class: "w-full px-6 py-3 flex flex-col items-center justify-center" };
const _hoisted_6 = { class: "text-badge flex items-center justify-end w-full" };
const _hoisted_7 = { key: 0 };
import { ref, watch, computed, defineAsyncComponent } from 'vue';
import { useHomeFilterStore } from './homeFilterStore';
import { ChevronLeft, Loader, X } from 'lucide-vue-next';
import { FilterMenuType } from './home-filter-type';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-filter-dialog',
    setup(__props) {
        const homeFilterStore = useHomeFilterStore();
        const showContent = ref(false);
        // Lazy-loaded components with caching
        const filterComponents = {
            [FilterMenuType.FILTER]: defineAsyncComponent(() => import('./home-filter-dialog-menu.vue')),
            [FilterMenuType.BRAND]: defineAsyncComponent(() => import('./home-filter-dialog-brand.vue')),
            [FilterMenuType.CONDITION]: defineAsyncComponent(() => import('./home-filter-dialog-condition.vue')),
            [FilterMenuType.PRICE]: defineAsyncComponent(() => import('./home-filter-dialog-price.vue')),
            [FilterMenuType.YEAR]: defineAsyncComponent(() => import('./home-filter-dialog-year.vue')),
            [FilterMenuType.SIZE]: defineAsyncComponent(() => import('./home-filter-dialog-size.vue')),
            [FilterMenuType.OTHER]: defineAsyncComponent(() => import('./home-filter-dialog-other.vue')),
        };
        const currentFilterComponent = computed(() => {
            return filterComponents[homeFilterStore.currentState];
        });
        // Watch for when the filter menu becomes visible
        watch(() => homeFilterStore.showFilterMenu, (newValue) => {
            if (newValue) {
                setTimeout(() => {
                    showContent.value = true;
                }, 100);
            }
        });
        const closeFilterMenu = () => {
            showContent.value = false;
            setTimeout(() => {
                homeFilterStore.showFilterMenu = false;
                homeFilterStore.currentState = FilterMenuType.FILTER;
            }, 100);
        };
        return (_ctx, _cache) => {
            const _component_loader_view = _resolveComponent("loader-view");
            return (_unref(homeFilterStore).showFilterMenu)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fixed left-0 top-0 z-50 h-[var(--safe-height)] w-full bg-black/30 backdrop-blur-sm flex items-center justify-center",
                    onClick: _cache[4] || (_cache[4] = ($event) => (closeFilterMenu()))
                }, [
                    _createVNode(_Transition, {
                        "enter-active-class": "transition ease-out duration-100 transform",
                        "enter-from-class": "opacity-0 scale-95",
                        "enter-to-class": "opacity-100 scale-100",
                        "leave-active-class": "transition ease-in duration-75 transform",
                        "leave-from-class": "opacity-100 scale-100",
                        "leave-to-class": "opacity-0 scale-95"
                    }, {
                        default: _withCtx(() => [
                            (showContent.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "w-11/12 h-5/6 bg-white rounded-[20px] border border-badge overflow-auto scroll-smooth flex flex-col justify-start items-center max-w-[500px]",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_1, [
                                        _createVNode(_unref(ChevronLeft), {
                                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(homeFilterStore).changeMenu(_unref(FilterMenuType).FILTER))),
                                            class: _normalizeClass(['size-8 text-badge', _unref(homeFilterStore).currentState !== _unref(FilterMenuType).FILTER ? 'opacity-1' :
                                                    'opacity-0'])
                                        }, null, 8, ["class"]),
                                        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(homeFilterStore).title), 1),
                                        _createVNode(_unref(X), {
                                            class: "size-8 text-badge",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (closeFilterMenu()))
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_3, [
                                        (_openBlock(), _createBlock(_KeepAlive, null, [
                                            (_openBlock(), _createBlock(_Suspense, null, {
                                                fallback: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_4, [
                                                        _createVNode(_component_loader_view)
                                                    ])
                                                ]),
                                                default: _withCtx(() => [
                                                    (_openBlock(), _createBlock(_resolveDynamicComponent(currentFilterComponent.value), {
                                                        key: _unref(homeFilterStore).currentState
                                                    }))
                                                ]),
                                                _: 1
                                            }))
                                        ], 1024))
                                    ]),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("div", _hoisted_6, [
                                            (!_unref(homeFilterStore).isCallingApi)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(homeFilterStore).market.pagination.total) + " results", 1))
                                                : (_openBlock(), _createBlock(_unref(Loader), {
                                                    key: 1,
                                                    class: "size-6 animate-spin"
                                                }))
                                        ]),
                                        _createElementVNode("div", {
                                            class: "w-full bg-primary2 text-white text-center py-2.5 rounded-[8px]",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (closeFilterMenu()))
                                        }, [...(_cache[5] || (_cache[5] = [
                                                _createElementVNode("div", null, "Apply Filter(s)", -1)
                                            ]))])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
